<button
    *ngIf="buttonText || buttonIcon"
    type="button"
    [icon]="this.buttonIcon"
    [label]="this.buttonText"
    pButton
    (click)="displayTable = true"
    style="margin-right: 10px;"
></button>
<p-dialog
    [header]="this.modalText"
    [(visible)]="displayTable"
    [style]="{width: '80%', align: 'center' }"
    appendTo="body"
    [resizable]="true"
    [maximizable]="true"
    [closeOnEscape]="true"
    (onHide)="closed()"
    (onShow)="onShow()"
>
    <div class="ui-g">
        <div class="ui-g-12">
            <tree-table class="tree-table-custom-align"
                *ngIf="!error"
                [inputTreeNodes]="accountsForTable"
                [treeColumns]="tableColumns"
                [loadingTreeNodes]="loading"
                [selectionMode]="none"
            ></tree-table>
            <p *ngIf="error">{{error}}</p>
        </div>
    </div>
</p-dialog>
